<template>
  <div class="header-content">
    <img v-if="!isAuthorized" alt="матрешка" class="header-text" src="static-frontend/svg/header-text.svg">
    <div class="header-buttons" v-else>

      <router-link @click="closeMobileMenu" :to="{name: 'Home'}" :class="{current: $route.name === 'Home'}">
        <span class="ic-home"></span>
        <span class="icon-title">{{ getRouteTitleByName('Home') }}</span>
      </router-link>

      <router-link @click="closeMobileMenu" :to="{name: $route.name === 'EditHouse' ? '': 'AddHouse'}"
                   :class="{current: $route.name === 'AddHouse' || $route.name === 'EditHouse'}">
        <span :class="$route.name === 'EditHouse' ? 'ic-edit-house': 'ic-add-house'"></span>
        <span class="icon-title">{{
            getRouteTitleByName($route.name === 'EditHouse' ? 'EditHouse' : 'AddHouse')
          }}</span>
      </router-link>

      <router-link @click="closeMobileMenu" :to="{name: 'Report'}"
                   :class="{current: $route.name === 'Report'}">
        <span class="ic-add-report"></span>
        <span class="icon-title">{{ getRouteTitleByName('Report') }}</span>
      </router-link>

      <a v-if="$route.name === 'HouseElements'" class="current">
        <span class="ic-mark"></span>
        <span class="icon-title">{{ getRouteTitleByName('HouseElements') }}</span>
      </a>
    </div>

    <a class="header-logout" v-if="isAuthorized" @click="onLogout">
      <span class="ic-logout"></span>
      <span class="icon-title">Выйти</span>
    </a>
  </div>
</template>

<script>
import useLogin from "@/composables/UseLogin";

export default {
  name: "HeaderButtons",
  setup() {
    return {
      ...useLogin()
    }
  },
  methods: {
    getRouteTitleByName(name) {
      return this.$router.getRoutes().find(i => i.name === name).meta.title
    },
    closeMobileMenu() {
      this.$emit('closeMobileMenu')
    },
    onLogout() {
      this.logout()
      this.closeMobileMenu()
    }
  }
}
</script>

<style lang="scss" scoped>
.header-content {
  height: 100%;
  padding: 2rem 0;
  position: relative;
  display: flex;
  justify-content: center;

  .header-text {
    height: 60%;
    width: 100%;
  }

  .header-buttons {
    display: flex;
    flex-direction: column;
    width: 100%;

    a {
      width: 100%;
      margin: .5rem 0;
      height: 35px;
      position: relative;
      text-align: center;
      text-decoration: none;
      display: flex;
      justify-content: center;
      align-items: center;

      .icon-title {
        margin-left: .5em;
        color: var(--default-icon-color);
        display: none;
      }

      &.current {

        span {
          color: var(--common-button);
        }

        &:after {
          content: '';
          width: 5px;
          border-radius: 5px 0 0 5px;
          background: var(--common-button);
          height: 100%;
          position: absolute;
          right: 0;
        }
      }
    }
  }

  .header-logout {
    cursor: pointer;
    position: absolute;
    bottom: 1rem;
    text-decoration: none;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    .icon-title {
      margin-left: .5em;
      color: var(--default-icon-color);
      display: none;
    }
  }
}

@media (max-width: 800px) {
  .header-content {
    .header-logout {
      bottom: 0;
      justify-content: flex-start;

      .icon-title {
        display: block;
      }
    }

    .header-buttons a {
      justify-content: flex-start;

      .icon-title {
        display: block;
      }

      &.current:after {
        right: -1rem;
      }
    }
  }
}
</style>
